export default __webpack_public_path__ + "static/media/Active Wear & Inner Wear 2.743b0996.jpg";